export default __webpack_public_path__ + "static/media/bannerImage.254cd315.png";